import type React from "react";
import { ReactComponent as Svg } from "./assets/bet-multi.svg";
import * as styles from "./Icon.module.scss";

type BetMultiProps = React.SVGProps<SVGSVGElement>;

export const BetMulti = ({ className, ...props }: BetMultiProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
